// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface SetDeleteModalIsOpenParameter {
    isOpen: boolean;
}

type HandlerType = Handler<SetDeleteModalIsOpenParameter>;

export const DispatchSetDeleteModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/SetDeleteModalIsOpen",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetDeleteModalIsOpen];

const setDeleteModalIsOpen = createHandlerChainRunner(chain, "SetDeleteModalIsOpen");
export default setDeleteModalIsOpen;
